import { ActivationTypes, IActivation } from './activation';

export namespace Employee {
  export enum RegistrationStatus {
    NOT_STARTED = 'NOT_STARTED',
    STARTED = 'STARTED',
    PENDING_APPROVAL = 'PENDING_APPROVAL',
    COMPLETED = 'COMPLETED',
  }

  export enum EmployeeFormCompletionStatus {
    INCOMPLETE = 'INCOMPLETE',
    COMPLETE = 'COMPLETE',
  }

  export enum Relationship {
    AUNT = 'AUNT',
    BROTHER = 'BROTHER',
    COUSIN = 'COUSIN',
    DAUGHTER = 'DAUGHTER',
    FATHER = 'FATHER',
    FRIEND = 'FRIEND',
    GRANDPARENT = 'GRANDPARENT',
    HUSBAND = 'HUSBAND',
    INLAW = 'INLAW',
    MOTHER = 'MOTHER',
    PARENTS = 'PARENTS',
    ROOMMATE = 'ROOMMATE',
    SISTER = 'SISTER',
    SON = 'SON',
    UNCLE = 'UNCLE',
    WIFE = 'WIFE',
  }
}

// TODO: Labor to deprecate this
export enum EmploymentStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  PENDING = 'PENDING',
  TRANSFERRED_OUT = 'TRANSFERRED_OUT',
  TERMINATED = 'TERMINATED',
  LEAVE_OF_ABSENCE = 'LEAVE_OF_ABSENCE',
}

export enum EmployeeStatus {
  PENDING = 'PENDING',
  HIRED = 'HIRED',
  TERMINATED = 'TERMINATED',
  LEAVE_OF_ABSENCE = 'LEAVE_OF_ABSENCE',
}

export enum BSLEmploymentStatus {
  ACTIVE = 'ACTIVE',
  SUSPENDED = 'SUSPENDED',
  TERMINATED = 'TERMINATED',
}

export const EmploymentStatusMapping = {
  [EmployeeStatus.HIRED]: BSLEmploymentStatus.ACTIVE,
  [EmployeeStatus.PENDING]: BSLEmploymentStatus.ACTIVE,
  [EmployeeStatus.LEAVE_OF_ABSENCE]: BSLEmploymentStatus.SUSPENDED,
  [EmployeeStatus.TERMINATED]: BSLEmploymentStatus.TERMINATED,
};

export enum LeaveOfAbsenceReasons {
  BACK_TO_SCHOOL = 'BACK_TO_SCHOOL',
  MEDICAL_LEAVE = 'MEDICAL_LEAVE',
  MILITARY_LEAVE = 'MILITARY_LEAVE',
  PERSONAL_LEAVE = 'PERSONAL_LEAVE',
  SYSTEM_GENERATED = 'SYSTEM_GENERATED',
  OTHER = 'OTHER',
}

// Maybe create interface for 'OTHER' being a custom string
export enum TerminationReasons {
  ATTENDANCE = 'ATTENDANCE',
  DISCIPLINARY_ACTION = 'DISCIPLINARY_ACTION',
  FAILURE_TO_MEET_STANDARDS = 'FAILURE_TO_MEET_STANDARDS',
  VOLUNTARY = 'VOLUNTARY',
  SYSTEM_GENERATED = 'SYSTEM_GENERATED',
  OTHER = 'OTHER',
}

export enum Gender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  NON_BINARY = 'NON_BINARY',
  PREFER_NOT_TO_SAY = 'PREFER_NOT_TO_SAY',
}

// TODO Fix this to be better
export const mapOfEmployment: Record<EmploymentStatus, IActivation> = {
  ACTIVE: { activationStatus: ActivationTypes.ACTIVE },
  INACTIVE: { activationStatus: ActivationTypes.INACTIVE },
  PENDING: { activationStatus: ActivationTypes.PENDING },
  TRANSFERRED_OUT: { activationStatus: ActivationTypes.INACTIVE, activationReason: 'TRANSFERRED_OUT' },
  LEAVE_OF_ABSENCE: {
    activationStatus: ActivationTypes.INACTIVE,
    activationReason: 'LEAVE_OF_ABSENCE',
    activationDetails: '', // Figure out how to define this as LOA enum type
  },
  TERMINATED: {
    activationStatus: ActivationTypes.INACTIVE,
    activationReason: 'TERMINATED',
    activationDetails: '', // Figure out how to define this as Termination enum type
  },
};

export enum JobStatus {
  FULL_TIME = 'FULL_TIME',
  PART_TIME = 'PART_TIME',
  HOURLY = 'HOURLY',
  SALARY_EXEMPT = 'SALARY_EXEMPT',
  SALARY_NON_EXEMPT = 'SALARY_NON_EXEMPT',
}
